/**
 * logout — signs the user out, clears all state, nukes the fetch cache,
 * signals other tabs via localStorage, and redirects to /login.
 */

import { invalidateUserDataCache } from '../sdk.js'
import { purgeAuthStorage } from '../clearAuthStorage.js'
import { clearActiveWorkspacePointer } from '../activeWorkspacePointer.js'

/**
 * @param {object} state       - DOMQL root state
 * @param {object} sdk         - SDK instance (flat sdk.logout method)
 * @param {object} queryClient - @symbo.ls/fetch queryClient
 */
export const logout = async (state, sdk, queryClient) => {
  await sdk.logout?.()

  for (const k of Object.keys(state)) state[k] = null
  state.preferences = {}
  state.themeMode = 'auto'
  state.lang = 'en'

  queryClient.clear()
  // Wipe profile, orgs, project list, and any other `__canvas_*`
  // localStorage entries so the next signed-in user can't see the
  // previous user's cached data on their first dashboard render.
  invalidateUserDataCache()
  // Purge stored auth credentials — sb-* (governance Supabase JWT),
  // symbols_* (SDK tokens), and the sdk_only-retry session flag. Shared
  // with bootShell._forceLogoutAndReauth so both logout paths leave the
  // same clean slate. Without this, post-mount logout left governance
  // tokens behind; the next sign-in could resurrect a stale session.
  purgeAuthStorage()
  localStorage.setItem('logout', String(Date.now()))
  // `activeOrg` migrated to `User.activeOrganization` (Mongo) — no
  // localStorage entry to clear. Kept the cleanup for `activeWorkspace`
  // and `activeWorkspaceProject` until those follow the same migration.
  clearActiveWorkspacePointer()
  localStorage.removeItem('activeWorkspaceProject')

  window.history.replaceState(null, '', '/login')
}
